import api from '@/api/api'

import Routes from '@/router/routes'

export default {
	name: 'sellers',
	data () {
		return {
			routes : Routes
		}
	},
	methods : {},
	components : {},
	created () {}
}


// WEBPACK FOOTER //
// ./src/components/private/sellers/script.js